import React, { useState, useEffect } from 'react';
import { PhonicsLesson, PhonicsClassStatus } from '@/api/types';
import { Modal } from '../../Modal';
import { TextArea } from '../../TextArea';
import { Button } from '../../buttons/Button';

interface ManageAddLessonNotesModalProps {
  onClose: () => void;
  onSave: (notes: string) => void;
  lesson: PhonicsLesson;
  phonicsClass: PhonicsClassStatus;
  loading?: boolean;
  error?: string;
}

export const ManageAddLessonNotesModal = ({
  onClose,
  onSave,
  lesson,
  phonicsClass,
  loading = false,
  error,
}: ManageAddLessonNotesModalProps) => {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    const phonicsClassStatus = phonicsClass.classLessonStatuses.find(
      (lessonStatus) => lessonStatus.lessonId === lesson.id,
    );

    setValue(phonicsClassStatus?.lessonNotes || '');
  }, [lesson, phonicsClass]);

  return (
    <Modal visible={!!lesson} onClose={onClose}>
      <h2 className="my-3 font-bold text-2xl">
        Please add notes for lesson {lesson.number} for class{' '}
        {phonicsClass.classId}
      </h2>

      <TextArea
        className="my-3"
        name="lesson-notes"
        value={value}
        onChange={(val) => setValue(val || '')}
      />

      {error && <p className="my-3 text-red-700">{error}</p>}

      <div className="flex gap-3">
        <Button style="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={() => onSave(value)} loading={loading}>
          Save
        </Button>
      </div>
    </Modal>
  );
};
